import { Grid3x3, Layers } from "lucide-react";
import type { AnalyticsFacet } from "../../../../stores/tars/tars-analytics-store";
import {
  FACET_LIST_MATRIX_ICON_COLOR,
  FACET_LIST_NORMAL_ICON_COLOR,
} from "../../tars-constants";
import { isFacetMatrixTable } from "./is-facet-matrix-table";

interface FacetListTypeIconProps {
  facet: AnalyticsFacet;
  selected: boolean;
}

export default function FacetListTypeIcon({ facet, selected }: FacetListTypeIconProps) {
  const isMatrix = isFacetMatrixTable(facet);
  const color = selected
    ? "#ffffff"
    : isMatrix
      ? FACET_LIST_MATRIX_ICON_COLOR
      : FACET_LIST_NORMAL_ICON_COLOR;
  const iconProps = {
    size: 18,
    strokeWidth: 1.75,
    className: "shrink-0",
    color,
    "aria-hidden": true as const,
  };

  if (isMatrix) {
    return <Grid3x3 {...iconProps} />;
  }

  return <Layers {...iconProps} />;
}
